
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm-2.622-4A1.39 1.39 0 016 14.598V5.402A1.39 1.39 0 017.378 4h5.572c.58 0 1.05.478 1.05 1.068 0 .59-.47 1.068-1.05 1.068H9.356a.927.927 0 00-.919.935v.836c0 .517.411.935.919.935h3.24c.58 0 1.05.478 1.05 1.068 0 .59-.47 1.068-1.05 1.068h-3.24a.927.927 0 00-.919.935v1.016c0 .517.411.935.919.935h3.594c.58 0 1.05.478 1.05 1.068 0 .59-.47 1.068-1.05 1.068H7.378"}})])
          )
        }
      }
    